<template>
  <v-container 
  v-if="isDataReady"
  fluid>
    <section-title-with-request-id
    :request-id="repairProp.number"
    title="pages.repair.repairRequestDetails"
    :subtitle="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'SUPERVISOR']) ? 'pages.repair.pleaseApproveOrRejectDetailTab' : null"
    subtitle-bold
    class="mb-3"/>
    <updatable-status-by-admin
    :data="repairProp"
    :loading="isLoading"
    :statusesFetcher="getRepairStatuses"
    :statusGetter="getStatusAsObject"/>
    <v-row dense class="mt-10">
      <v-col>
        <span v-if="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'SUPERVISOR'])" class="process-repair-tab-section-title">{{$t('pages.repair.partsForApproval')}}</span>
        <span v-else class="process-repair-tab-section-title">{{$t('pages.repair.partsInfo')}}</span>
      </v-col>
      <v-col
      v-if="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'SUPERVISOR'])"
      class="d-flex justify-end">
        <approval-comment-dialog-trigger
        @click="openApprovalCommentDialogForRequest"
        :value="newData.approvalComments['NEW']"
        :disable-on-empty="disabled"/>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <attachment-dialog
        v-if="attachmentDialog.model"
        v-model="attachmentDialog.model"
        :attachments.sync="attachmentDialog.attachments"
        preview/>
        <approval-comment-dialog
        v-if="approvalCommentDialog.model"
        v-model="approvalCommentDialog.model"
        :comment="approvalCommentDialog.comment"
        :status="approvalCommentDialog.status"
        :step-status="repairProp.status.key"
        :owner-id="approvalCommentDialog.ownerId"
        :saver="approvalCommentDialog.saver"
        :title="approvalCommentDialog.title"
        @success="onApprovalCommentSaved"
        :preview="approvalCommentPreviewMode"/>
        <main-data-table
        :headers="getHeaders"
        :items="newData.repairParts"
        number-pages
        :mark-items="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'SUPERVISOR']) && !disabled"
        set-image
        :with-search="false"
        :disabled="disabled"
        :page.sync="page"
        :size="-1"
        :items-per-page-options="[-1]"
        :total-elements="-1"
        hide-default-footer>
          <template
          v-slot:[`header.approvalComments`]="{}">
            {{$t(`headers.${areAllPartsRejected ? 'rejected' : 'approval'}Comment`)}}
          </template>


          <template v-slot:[`item.attachments`]="{ item }">
            <attachments-dialog-trigger
            @click="openAttachmentsDialog(item.attachments)"
            :attachments="item.attachments"
            disable-on-empty/>
          </template>
          <template v-slot:[`item.initialApproval`]="{ item }">
            <waiting-approval-label
            :status="item.initialApproval"/>
          </template>
          <template
          v-if="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'SUPERVISOR'])"
          v-slot:[`item.approval`]="{ item }">
            <waiting-approval-btns
            :current-status="item.initialApproval"
            :loading="isLoading"
            :disabled="disabled"
            @selected="(status) => changeInitialStatusSingle(item, status)"/>
          </template>
          <template
          v-if="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'SUPERVISOR', 'CLIENT'])"
          v-slot:[`item.approvalComments`]="{ item }">
            <approval-comment-dialog-trigger
            @click="openApprovalCommentDialogForPart(item, getApprovalCommentDialogTitleByRole(item.initialApproval))"
            :value="item.approvalComments['NEW']"
            :disable-on-empty="approvalCommentPreviewMode"/>
          </template>
        </main-data-table>

        <v-row 
        v-if="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'SUPERVISOR'])"
        class="mt-5"
        dense>
          <v-col>
            <process-repair-quick-btns
            :config="getQuickBtnsConfig"
            :loading.sync="isLoading"
            title="common.pressContinueWhenReady"
            on-success-repair-status-message="dialogs.messages.success.firstDetailsCompleted"/>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <export-xlsx-row
    :width="150"
    :height="50"
    :disabled="newData.repairParts.length === 0"
    :loading.sync="isLoading"
    class="px-4 mt-4"
    name="export.title.repairDetailTab"
    :exporter="getExporter"/>
  </v-container>
</template>
<script>
import ProcessRepairQuickBtns from '@/components/process-repair-tabs/ProcessRepairQuickBtns'
import MainDataTable from '@/components/common/MainDataTable'
import ExportXlsxRow from '@/components/common/ExportXlsxRow'
import UpdatableStatusByAdmin from '@/components/common/process-tabs/UpdatableStatusByAdmin'
import WaitingApprovalLabel from '@/components/common/process-tabs/WaitingApprovalLabel'
import WaitingApprovalBtns from '@/components/common/process-tabs/WaitingApprovalBtns'
import AttachmentDialog from '@/components/dialogs/AttachmentDialog'
import AttachmentsDialogTrigger from '@/components/common/triggers/AttachmentsDialogTrigger'
import ApprovalCommentDialog from '@/components/dialogs/ApprovalCommentDialog'
import ApprovalCommentDialogTrigger from '@/components/common/triggers/ApprovalCommentDialogTrigger'
import SectionTitleWithRequestId from '@/components/common/process-tabs/shared/SectionTitleWithRequestId'
import { getUserRole } from '@/services/authService'
//ENABLE_CHANGE_DIALOG - This method is needed for changes dialog.
//getTextByKeyInitialStatus
import { getObjectStatusByKey, getAvailableRepairStatuses,  } from '@/utils/statusesUtil'
import { changePartInitialStatus } from '@/repositories/repairRepo'
import { execHttpRequestThrowable } from '@/services/http'
//ENABLE_CHANGE_DIALOG - This method is needed for changes dialog.
// compareArrays
import { copyObj } from '@/utils/StringUtil'
import { exportRepairDetailTabXlsx } from '@/repositories/exportRepo'
import { saveRequestApprovalComment, savePartApprovalComment } from "@/repositories/repairRepo"
export default {
  name: 'DetailsTabRepair',
  components: {
    ProcessRepairQuickBtns,
    MainDataTable,
    UpdatableStatusByAdmin,
    WaitingApprovalLabel,
    WaitingApprovalBtns,
    ExportXlsxRow,
    AttachmentDialog,
    AttachmentsDialogTrigger,
    ApprovalCommentDialog,
    ApprovalCommentDialogTrigger,
    SectionTitleWithRequestId
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    disabled: Boolean
  },
  data() {
    return {
      // TODO: assign allowed roles to each column
      headers: [{
          text: 'headers.category',
          align: 'start',
          sortable: true,
          value: 'category',
          permissions: ["ADMIN", 'SUPER_ADMIN', "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
        },{
          text: 'headers.partName',
          align: 'start',
          sortable: true,
          value: 'partName',
          permissions: ["ADMIN", 'SUPER_ADMIN', "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
        }, {
          text: 'headers.serialNumber',
          align: 'start',
          sortable: true,
          value: 'serialNumber',
          permissions: ["ADMIN", 'SUPER_ADMIN', "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
        }, {
          text: 'headers.serviceTag',
          align: 'start',
          sortable: true,
          value: 'serviceTag',
          permissions: ["ADMIN", 'SUPER_ADMIN', "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
        }, {
          text: 'headers.problemDescription',
          align: 'start',
          sortable: true,
          value: 'problemDescription',
          permissions: ["ADMIN", 'SUPER_ADMIN', "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
        }, {
          text: 'headers.attachments',
          align: 'start',
          sortable: true,
          value: 'attachments',
          permissions: ["ADMIN", 'SUPER_ADMIN', "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
        }, {
          text: 'headers.initialApproval',
          align: 'start',
          sortable: true,
          value: 'initialApproval',
          permissions: ["ADMIN", 'SUPER_ADMIN', "SUPERVISOR", "SERVICE", "CLIENT", "SUSTAINABILITY_MANAGER"]
        }, {
          text: 'headers.approval',
          align: 'start',
          sortable: true,
          value: 'approval',
          permissions: ["ADMIN", 'SUPER_ADMIN', "SUPERVISOR",]
        }, {
          text: '', //NOTE: it will be processed dynamiclly.
          align: 'start',
          sortable: true,
          value: 'approvalComments',
          permissions: ["ADMIN", 'SUPER_ADMIN', "SUPERVISOR", "CLIENT"]
        }
      ],
      page: 1,
      newData: null,
      isLoading: false,
      isDataReady: false,
      attachmentDialog: {
        model: false
      },
      approvalCommentDialog: {
        model: false,
        comment: null,
        status: null,
        ownerId: -1,
        isItem: false,
        saver: null,
        title: undefined
      }
    }
  },
  computed: {
    repairProp: {
      get: function() {
        return this.$props.data
      },
      set: function(v) {
        this.$emit('update:data', v)
      }
    },
    getHeaders() {
      const headers = []
      for (const h of this.headers) {
        if (!h.permissions.includes(this.getRole)) continue

        if (this.disabled) {
          if (h.value === 'mark') continue
        }

        headers.push(h)
      }

      return headers
    },
    isMarkedApprovedBtnDisable() {
      
      return this.newData.repairParts.filter(p => p.mark === true).length === 0
    },
    getQuickBtnsConfig() {
      return [
        {
          name: 'RejectAll',
          events: {
            'click': () => this.setChangedDialogItems('REJECTED', false)
          },
          props: {
            'disabled': this.disabled
          }
        }, {
          name: 'ApproveAll',
          events: {
            'click': () => this.setChangedDialogItems('APPROVED', false)
          },
          props: {
            'disabled': this.disabled
          }
        }, {
          name: 'ApproveMarked',
          events: {
            'click': () => this.setChangedDialogItems('APPROVED', true)
          },
          props: {
            'disabled': this.disabled || this.isMarkedApprovedBtnDisable
          }
        }, {
          name: 'Continue',
          props: {
            'disabled': this.disabled || !this.newData.isAllowedToContinue
          }
        }
      ]
    },
    getExporter() {
      return async () => await exportRepairDetailTabXlsx(this.$route.params.id)
    },
    areAllPartsRejected() {
      const ARE_ALL_PARTS_REJECTED = this.newData.repairParts.filter(o => o.initialApproval === "APPROVED").length === 0
      return ARE_ALL_PARTS_REJECTED
    },
    approvalCommentPreviewMode() {
      return this.disabled || this.$parent.isRole(["CLIENT"])
    },
    getRole() {
      return getUserRole()
    },
  },
  methods: {
    async changeInitialStatusSingle(part, status) {
      await this.tryToChangeInitialStatus([{
        id: part.id,
        initialApproval: status
      }], false)
    },
    async tryToChangeInitialStatus(parts, showSuccessDialog) {
      const data = parts.map(p => {
        return {
          repairPartId: p.id,
          status: p.initialApproval
        }
      })
      const status = data[0].status
      const messages = {
        ignoreSuccessDialog: !showSuccessDialog,
        _200: this.$t(status === 'APPROVED' ? 'dialogs.messages.success.approvalDecisionSaved' : 'dialogs.messages.success.rejectionDecisionSaved')
      }
      const r = await execHttpRequestThrowable(async () => await changePartInitialStatus(this.$route.params.id, data),
      messages,
      v => this.isLoading = v)
      const ids = parts.map(p => p.id)
      //Update server parts
      this.repairProp.repairParts
        .filter(p => ids.includes(p.id))
        .forEach(p => p.initialApproval = String(status))
      //Update local parts
      this.newData.repairParts
        .filter(p => ids.includes(p.id))
        .forEach(p => p.initialApproval = String(status))

      this.newData.isAllowedToContinue = r.response.data
    },
    setChangedDialogItems(status, isMarkBtn) {
      const filteredParts = this.newData.repairParts.filter(p => (isMarkBtn && p.mark && p.initialApproval !== status) || (!isMarkBtn && p.initialApproval !== status))
      if (filteredParts.length === 0) return
      this.tryToChangeInitialStatus(filteredParts.map(p => {
        return {
          id: p.id,
          initialApproval: status
        }
      }))
      // NOTE: ENABLE_CHANGE_DIALOG - Enable this code, if changes dialog is needed.
      //-----------------------------------------------------------------
      // const newParts = filteredParts.map(p => {
      //   return {
      //     rowNumber: p.rowNumber,
      //     initialApproval: status
      //   }
      // })
      // const oldParts = filteredParts.map(p => {
      //   return {
      //     rowNumber: p.rowNumber,
      //     initialApproval: p.initialApproval
      //   }
      // })

      // const props = [
      //   {
      //     field: 'textFields.approval',
      //     prop: 'initialApproval',
      //     getter: getTextByKeyInitialStatus
      //   }
      // ]

      // this.$changesDialog.open(
      //   'dialogs.titles.changes',
      //   compareArrays(oldParts, newParts, props),
      //   async () => await this.tryToChangeInitialStatus(filteredParts.map(p => {
      //     return {
      //       id: p.id,
      //       initialApproval: status
      //     }
      //   }), true),
      //   true
      // )
      //-----------------------------------------------------------------
    },
    openAttachmentsDialog(attachments) {
      this.attachmentDialog = {
        model: true,
        attachments
      }
    },
    openApprovalCommentDialogForPart({approvalComments, initialApproval, id}, overriedenTitle) {
      this.approvalCommentDialog = {
        model: true,
        comment: approvalComments['NEW'],
        status: initialApproval,
        ownerId: id,
        isItem: true,
        saver: savePartApprovalComment,
        title: overriedenTitle
      }
    },
    openApprovalCommentDialogForRequest() {
      this.approvalCommentDialog = {
        model: true,
        comment: this.newData.approvalComments['NEW'],
        status: "REQUEST",
        ownerId: Number(this.$route.params.id),
        isItem: false,
        saver: saveRequestApprovalComment
      }
    },
    onApprovalCommentSaved({ownerId, comment}) {
      // NOTE: for part
      if (this.approvalCommentDialog.isItem) {
        //Update server parts
        this.repairProp.repairParts
          .filter(p => p.id === ownerId)
          .forEach(p => p.approvalComments['NEW'] = String(comment))
        //Update local parts
        this.newData.repairParts
          .filter(p => p.id === ownerId)
          .forEach(p => p.approvalComments['NEW'] = String(comment))
      }
      // NOTE: for whole request
      else {
        //Update server parts
        this.repairProp.approvalComments["NEW"] = comment
        //Update local parts
        this.newData.approvalComments["NEW"] = comment
      }

      this.approvalCommentDialog.model = false
    },
    getRepairStatuses() {
      return getAvailableRepairStatuses()
    },
    getStatusAsObject(s) {
      return getObjectStatusByKey(s)
    },
    getApprovalCommentDialogTitleByRole(status) {
      if (this.$parent.isRole(["CLIENT"])) {
        switch(status) {
          case "APPROVED": return "dialogs.titles.whyWasPartApproved"
          case "REJECTED": return "dialogs.titles.whyWasPartRejected"
          default: return "dialogs.titles.partUpcomingStatusDescription"
        }
      }

      return undefined
    }
  },
  mounted() {
    this.newData = {
      status: this.repairProp.status,
      approvalComments: copyObj(this.repairProp.approvalComments),
      repairParts: this.repairProp.repairParts.map((p, i) => {
        const newPart = copyObj(p)
        newPart.mark = this.$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'SUPERVISOR']) ? false : null
        newPart.rowNumber = i + 1
        return newPart
      }),
      isAllowedToContinue: this.repairProp.isAllowedToContinue
    }
    this.repairProp.requestId = this.repairProp.number
    this.isDataReady = true
  }
}
</script>
<style>

</style>